import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, finalize, of, switchMap, tap } from 'rxjs';
import { FacebookFormConfiguration, FacebookFormLogs } from 'src/app/core/models/social-forms-configurations/facebook-form-configuration.model';
import { SocialFormsFacebookService } from 'src/app/features/lead-injector/services/social-forms-facebook.service';
import { GlobalSpinnerActions } from '../../../global-spinner/actions-types';

@Component({
    selector: 'app-sidenav-content-facebook-form-logs',
    templateUrl: './sidenav-content-facebook-form-logs.component.html',
    styleUrls: ['./sidenav-content-facebook-form-logs.component.scss'],
    standalone: false
})
export class SidenavContentFacebookFormLogsComponent {

  @Input() set formConfiguration(configuration: FacebookFormConfiguration) {
    of(void 0).pipe(
      tap(() => this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())),
      switchMap(() => this.socialFormsFacebookService.searchFormLogs$(configuration.formId, 0, 20, configuration.id)),
      tap((logs) => this.logs = logs),
      finalize(() => this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner())),
    ).subscribe()
  }

  logs: FacebookFormLogs[] = []

  selectedLog: FacebookFormLogs | undefined
  logPayloadSidenavOpen: boolean = false

  constructor(private readonly appStore: Store,
    private readonly socialFormsFacebookService: SocialFormsFacebookService) {

  }

  openLogDetail(log: FacebookFormLogs) {
    this.selectedLog = log
    this.logPayloadSidenavOpen = true
  }
}
